// The browser-side twin of backend Services/PhoneValidation.cs and of
// badPhone() in HtmlPage.GateScript. All three enforce the same rule and are
// tested against the same case table; change one and change the others.
//
// India gets an exact check because it is the common case and has a fixed
// shape. Everywhere else only has to look like a phone number: rejecting a
// legitimate foreign number to enforce a format costs a signup, and this is a
// marketing requirement, not a billing system.

export const digitsOnly = (value) => (value || "").replace(/[^0-9]/g, "");

// Returns an error message, or "" when the number is usable.
export const phoneError = (countryCode, phoneNumber) => {
  const bare = digitsOnly(phoneNumber);
  if (!bare) return "Enter your WhatsApp number.";

  if (digitsOnly(countryCode) === "91") {
    if (bare.length !== 10) return "An Indian number is 10 digits.";
    if ("6789".indexOf(bare.charAt(0)) < 0)
      return "That does not look like a mobile number.";
    return "";
  }

  if (bare.length < 7 || bare.length > 15)
    return "That does not look like a phone number.";
  return "";
};
